import instance from "@/services/api";

export const tierFactAPI = {
  async getResidents() {
    return await instance()
      .get("/tier/resident/read/")
      .then((res) => res?.data);
  },
  async getBlocks(resident_id) {
    return await instance()
      .get("/tier/block/read/", { params: { resident_id } })
      .then((res) => res?.data);
  },
  async getWorkGroups(block_id) {
    return await instance()
      .get("/tier/work_group/read/", { params: { block_id } })
      .then((res) => res?.data);
  },
  async getWorkTaskFact(work_group_id, work_group_level_id = null) {
    const params = { work_group_id };
    if (work_group_level_id) {
      params.work_group_level_id = work_group_level_id;
    }
    return await instance()
      .get("/tier/work_task_plan_fact/read/", { params })
      .then((res) => res?.data);
  },
  async getWorkGroupLevelNum(work_group_id) {
    return await instance()
      .get("/tier/work_group_level_num/read/", { params: { work_group_id } })
      .then((res) => res?.data);
  },
  async updateWorkTaskFact(body) {
    return await instance()
      .post("/tier/work_task_fact/upd/", body)
      .then((res) => res?.data);
  },
  async deleteWorkTaskFact(body) {
    return await instance()
      .post("/tier/work_task_fact/delete/", body)
      .then((res) => res?.data);
  },
  async getGprValues(work_group_id, work_days, work_group_level_id = null) {
    const body = { 
      work_group_id, 
      work_days // Передаем массив дат напрямую
    };
    if (work_group_level_id) {
      body.work_group_level_id = work_group_level_id;
    }
    return await instance()
      .post("/tier/gpr_value/get/", body)
      .then((res) => res?.data);
  },
};

